<template>
    <div v-if="loading" class="loading-screen">
    </div>

    <div v-else>
        <vue-headful title="Maak je profiel compleet" />
        <Header page_title="Maak je profiel compleet" goBackClass="invisible" :do-not-show-all="!this.prevRoute || this.prevRoute.name !== 'applicant-edit'" />
        <div class="pt-3 px-4 mx-2 pb-4 questionnaire">
            <div class="container-fluid px-0 pb-1 mb-2">
                <form @submit.prevent="onSubmit">
                    <div class="step-question">
                        <button type="submit" ref="submit" hidden>submit</button>
                        <template v-if="!prevRoute || (prevRoute.name !== 'applicant-edit' && prevRoute.name !== 'applicant-dashboard')">
                            <register-steps :steps="{1:'Gegevens',2:'Ervaringen',3:'Aan de slag!'}" :totalAnswered="answered" currentStep="2"></register-steps>
                        </template>
                        <div ref="step">
                            <template v-if="step === 1">
                                <div class="sd-title medium step-container">
                                    <span class="steps">1/3</span>
                                    Voor welke zorgfunctie(s) ben je bevoegd?
                                </div>
                                <div class="form pt-2">
                                    <div class="slide-bar" v-if="form.user_answers[questions[step].id]">
                                        <li v-for="item in answers[step]" v-bind:key="item.id" style="list-style: none">
                                            <div class="custom-control custom-checkbox">
                                                <input
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    v-model="form.user_answers[questions[step].id]['answer_id'][item.id]"
                                                    :value="item.id"
                                                    v-bind:id="`position-` + item.id"
                                                />
                                                <label
                                                    class="custom-control-label"
                                                    v-bind:for="`position-` + item.id"
                                                >{{ item.answer }}</label
                                                >
                                            </div>
                                        </li>
                                    </div>
                                </div>
                            </template>
                        </div>

                        <div ref="step">
                            <template v-if="step === 2">
                                <div class="sd-title medium step-container">
                                    <span class="steps">2/3</span>
                                    Met welke doelgroepen heb je ervaring?
                                </div>
                                <div class="form pt-2">
                                    <div class="slide-bar" v-if="form.user_answers[questions[step].id]">
                                        <li v-for="item in answers[step]" v-bind:key="item.id" style="list-style: none">
                                            <div class="custom-control custom-checkbox">
                                                <input
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    v-model="
                                                        form.user_answers[questions[step].id]['answer_id'][item.id]"
                                                    :value="item.id"
                                                    v-bind:id="`position-` + item.id"
                                                />
                                                <label
                                                    class="custom-control-label"
                                                    v-bind:for="`position-` + item.id"
                                                >{{ item.answer }}</label
                                                >
                                            </div>
                                        </li>
                                    </div>
                                </div>
                            </template>
                        </div>

                        <div ref="step">
                            <template v-if="step === 3">
                                <div class="sd-title medium step-container">
                                    <span class="steps">3/3</span>
                                    In welke type zorg ben je gespecialiseerd?
                                </div>

                                <div class="form pt-2" v-if="form.user_answers[questions[step].id]">
                                    <div v-for="(items, groupName) in groupedAnswersStep3" :key="groupName" class="subcategory-group">
                                        <h5 class="subcategory-header">{{ groupName }}</h5>
                                        <li v-for="item in items" :key="item.id" style="list-style: none">
                                            <div class="custom-control custom-checkbox">
                                                <input
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    v-model="form.user_answers[questions[step].id]['answer_id'][item.id]"
                                                    :value="item.id"
                                                    :id="`position-` + item.id"
                                                />
                                                <label
                                                    class="custom-control-label"
                                                    :for="`position-` + item.id"
                                                >{{ item.answer }}</label>
                                            </div>
                                        </li>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div hidden>
                        <v-stepper ref="stepper" :steps="steps" v-model="step"></v-stepper>
                    </div>
                </form>
            </div>
        </div>
        <div class="step next-btn">
            <div class="px-4 mx-2">
                <button
                    v-if="step < steps && prevRoute && prevRoute.name === 'applicant-edit'"
                    type="button"
                    title="Volgende"
                    class="btn btn-warning btn-block"
                    @click="nextStep"
                >
                    Volgende
                </button>
                <button
                    v-else-if="step < steps"
                    type="button"
                    title="Volgende stap"
                    class="btn btn-warning btn-block"
                    @click="nextStep"
                >
                    Volgende stap
                </button>
                <!-- @click="$refs.stepper.next()" -->
                <!-- if action is save Opslaan
                if action is next Volgende-->
                <button
                    v-if="step == steps"
                    type="button"
                    title="Volgende"
                    class="btn btn-warning btn-block"
                    @click="triggerSubmit"
                >
                    {{ action == "next" ? "Volgende" : "Opslaan" }}
                </button>
            </div>
        </div>
        <div v-if="done" class="fullscreen-notif position-fixed">
            <div class="d-flex min-height align-items-center">
                <div class="container-fluid px-4 mx-2">
                    <div class="text-center pb-1">
                        <div class="icon svg mb-4 pb-1">
                            <svg-icon icon="success"></svg-icon>
                        </div>
                        <div class="sd-title large text-uppercase bold text-white text-center mb-4">
                            Dank voor het invullen!
                        </div>
                        <div>
                            Nu je profiel helemaal compleet is, word je nog beter gevonden. Op naar de leukste (inval)opdrachten!
                        </div>
                    </div>
                </div>

                <div class="footer-btn">
                    <div class="container-fluid px-4 mx-2">
                        <router-link
                            :to="{
                                name: 'applicant-dashboard'
                            }"
                            title="Naar mijn dashboard"
                            class="btn btn-light btn-block"
                            v-ripple="'rgba(192, 189, 187, 0.35)'"
                        >Naar mijn dashboard</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { VStepper } from "vue-stepper-component";
import VueSlideBar from "vue-slide-bar";
import Subjects from "@/components/subjects.vue";

export default {
    components: {
        VStepper,
        VueSlideBar,
        Subjects
    },
    data: function() {
        return {
            raw: "",
            years_experience: 0,
            steps: 0,
            step: 1,
            answered: 0,
            done: null,
            user: "",
            education: null,
            questions: {},
            questions_array: {},
            answers_array: {},
            answers: {},
            subject_answers: {},
            form: {
                user_answers: {},
                about_subject_answers: null
            },
            prevRoute: null,
            loading: true,
        };
    },
    created() {
        this.steps = 3;
    },
    props: ["action", "question_branch"],
    async mounted() {
        this.$store.state.loading = true;
        this.loading = true;
        await this.fetchData();
        this.loading = false;
        this.$store.state.loading = false;
    },
    watch: {
        $route: "fetchData",
        step: {
            handler() {
                this.answered = Math.ceil((this.step / this.steps) * 100);
            }
        },
        form: {
            handler: function() {
                localStorage.setItem("form-pending", JSON.stringify(true));
            },
            deep: true
        }
    },
    methods: {
        async fetchData() {
            await this.getQuestions();
            await this.getAnswers();
            await this.fillForm();
            await this.getUserAnswers();
            this.user = JSON.parse(localStorage.getItem("user"));
            if (this.user.education) {
                this.education = JSON.parse(this.user.education);
            }
            localStorage.removeItem("form-pending");
        },
        // get questions
        async getQuestions() {
            let promises = [];
            var q_url = this.$apiURI + "/question/experience/3/";
            var i = 1;
            var question_number = 1;

            while (i <= this.steps) {
                //assign questions
                promises.push(
                    new Promise(resolve => {
                        this.$http({
                            method: "GET",
                            url: q_url + question_number
                        }).then(
                            result => {
                                var q_id = result.data.data[0].id;
                                var q_number = result.data.data[0].number;

                                this.$set(this.questions, q_number, {
                                    id: result.data.data[0].id,
                                    display: result.data.data[0].display
                                });
                                this.$set(this.questions_array, q_number, q_id);
                                resolve();
                            },
                            error => {
                                console.error(error);
                            }
                        );
                        i++;
                        question_number++;
                    })
                );
            }
            return Promise.all(promises);
        },
        //assign answers
        async getAnswers() {
            let promises = [];
            var a_url = this.$apiURI + "/answers/3/";

                var arr = {
                    qualification: 1,
                    group: 2,
                    specialization: 3,
                }

            Object.keys(arr).forEach(itemKey => {
                promises.push(
                    new Promise(resolve => {
                        this.$http({
                            method: "GET",
                            url: a_url + itemKey
                        }).then(
                            result => {
                                this.$set(
                                    this.answers,
                                    arr[itemKey], //qnumber
                                    result.data.data
                                );

                                var answerIds = {};
                                for (var v in result.data.data) {
                                    answerIds[result.data.data[v].id] = false;
                                }
                                this.$set(this.answers_array, arr[itemKey], answerIds);
                                resolve();
                            },
                            error => {
                                console.error(error);
                            }
                        );
                    })
                );
            });

            return Promise.all(promises);
        },
        async fillForm() {
            return new Promise(resolve => {
                Object.keys(this.questions_array).forEach(questionNumber => {
                    var question_id = this.questions_array[questionNumber];
                        this.$set(this.form.user_answers, question_id, {
                            answer_id: this.answers_array[questionNumber]
                       });
                });
                resolve();
            });
        },
        async getUserAnswers() {
            return new Promise((resolve, reject) => {
                var url = "applicant/answers/raw/3/experience";

                let user_token = JSON.parse(localStorage.getItem("user-token"));
                this.$http
                    .get(this.$apiURI + "/" + url, {
                        headers: {
                            Authorization: "Bearer " + user_token,
                            Accept: "application/json"
                        }
                    })
                    .then(resp => {
                        if (resp.data.data) {
                            this.raw = resp.data.data;
                            for (var obj in this.raw) {
                                if (this.raw[obj].question_id === 1 || this.raw[obj].question_id === 31 || this.raw[obj].question_id === 52) {
                                    this.form.user_answers[this.raw[obj].question_id] = [];
                                    this.form.user_answers[this.raw[obj].question_id][
                                        "answer"
                                        ] = this.raw[obj].answer;
                                }
                                else if (this.raw[obj].question_id === 59) {
                                    this.form.user_answers[this.raw[obj].question_id] = [];
                                    this.form.user_answers[this.raw[obj].question_id][
                                        "answer"
                                        ] = this.raw[obj].answer;

                                    this.form.about_subject_answers = this.raw[obj].answer;
                                }
                                else {
                                    this.form.user_answers[this.raw[obj].question_id][
                                        "answer_id"
                                        ][this.raw[obj].answer_id] = true;
                                }
                            }
                        }
                        return resolve();
                    })
                    .catch(() => {
                        // console.log(error);
                        const notification = {
                            type: "danger",
                            message: "Er is een fout opgetreden.",
                            error: true
                        };
                        this.$store.dispatch("notification/replace", notification, {
                            root: true
                        });
                        return reject(null);
                    });
            });
        },
        triggerSubmit() {
            var elem = this.$refs.submit;
            elem.click();
        },
        async onSubmit() {
            var next = this.validateForm();
            if (next) {
                // continue
                await this.saveExperience();
                await this.updateLocalUser();
                localStorage.removeItem("questionBranch");
            }
        },
        async saveExperience() {
            return new Promise(resolve => {
                var user_token = JSON.parse(localStorage.getItem("user-token"));
                var url = this.$apiURI + "/user_answer/experience/3";
                let formData = {
                    user_answer: this.form["user_answers"],
                    about_subject_answers: this.form["about_subject_answers"],
                    limit: 10
                };
                this.$http
                    .post(url, formData, {
                        headers: {
                            Authorization: "Bearer " + user_token,
                            Accept: "application/json"
                        }
                    })
                    .then(() => {
                        // console.log(success);
                        this.done = true;
                        console.log(this.done);
                        localStorage.removeItem("form-pending");
                        resolve();
                    })
                    .catch(() => {
                        // console.log(error.response.data);
                        this.done = true;
                        // console.log(this.done);
                        localStorage.removeItem("form-pending");
                        resolve();
                    });
            });
        },
        nextStep() {
            var next = this.validateForm();
            window.scrollTo(0,0);
            if (next) {
                this.$refs.stepper.next();
            }
        },
        validateForm() {
                var $checkboxes = $('input[type="checkbox"]:visible');
                if ($checkboxes.length) {
                    var checkedCheckboxes = $('input[type="checkbox"]:visible:checked')
                        .length;
                    if (!checkedCheckboxes) {
                        alert("Selecteer één of meerdere antwoorden om door te gaan.");
                        return false;
                    }
                } else {
                    return true;
                }
            return true;
        },
        filteredAnswersForStep(step) {
            // For steps other than 3, return the original answers list
            if (step !== 3) {
                return this.answers[step] || [];
            }

            // Get question id for step 2
            const step2QuestionId = this.questions_array && this.questions_array[2];
            if (!step2QuestionId) {
                return this.answers[3] || [];
            }

            const selectionMap = (this.form.user_answers[step2QuestionId] && this.form.user_answers[step2QuestionId].answer_id) || {};

            // Build a set of selected answer names from step 2
            const selectedNames = new Set();
            (this.answers[2] || []).forEach(ans => {
                if (selectionMap[ans.id]) {
                    selectedNames.add(ans.answer);
                }
            });

            // If nothing selected (shouldn't happen due to validation), return full list as fallback
            if (selectedNames.size === 0) {
                return this.answers[3] || [];
            }

            // Filter specializations (step 3) by sub_category matching selected step-2 answers
            return (this.answers[3] || []).filter(a => {
                return a && a.sub_category && selectedNames.has(a.sub_category);
            });
        }
    },
    computed: {
        groupedAnswersStep3() {
            if (this.step !== 3) return [];

            const answers = this.filteredAnswersForStep(3);
            const groups = {};

            answers.forEach(item => {
                const group = item.sub_category || "Overig";
                if (!groups[group]) groups[group] = [];
                groups[group].push(item);
            });

            return groups;
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from;
        });
    },
    beforeRouteLeave(to, from, next) {
        this.savePending(to, from, next);
    }
};
</script>

<style scoped>
.card {
    border-radius: 5px;
    overflow: hidden;
}
.card-body {
    min-height: 135px;
}

.range-values div {
    position: relative;
    margin-top: -2px;
}
.range-values .float-left {
    left: -3px;
}
.range-values .float-right {
    right: -8px;
}

.fullscreen-notif .icon.svg svg {
    right: -22px;
}

/deep/.step-question .slide-bar {
    padding-left: 10px;
    padding-right: 10px;
}

.subcategory-group {
    display: flex;
    flex-wrap: wrap;
    column-gap: 10px;
}

.subcategory-group li {
    width: 45%;
}

.subcategory-header {
    width: 100%;
    font-weight: bold;
    margin-top: 30px;
    margin-bottom: 10px;
}

.step-question .notification-container {
    margin-top: 25px;
}
.questionnaire {
    padding-bottom:4rem!important;
}
</style>
